// extracted by mini-css-extract-plugin
module.exports = {"form":"Username_form__133nk","horizontaldiv":"Username_horizontaldiv__3upcV","paragraph":"Username_paragraph__RxeBp"};